import React, { PropTypes, PureComponent } from 'react';
import classNames from 'classnames';
import { composeUrlFromUrlParams } from '../UrlUtils';
import { history } from '../../modules/App/AppContainer';

class ProductFamilyItem extends PureComponent {

  constructor(props) {
    super(props);
    this.changeRoute = this.changeRoute.bind(this);
  }

  changeRoute() {
    const url = composeUrlFromUrlParams(this.props.urlParams, 'productId', this.props.productId);
    history.push(url);
  }

  render() {
    const productFamilyItemClasses = classNames(
      'mt-product-family-item',
      {
        'mt-product-family-item-active': this.props.isProductActive,
      });

    return (
      <div
        className={productFamilyItemClasses}
        onClick={this.changeRoute}
      >{this.props.label}</div>
    );
  }
}

ProductFamilyItem.propTypes = {
  label: PropTypes.string,
  productId: PropTypes.string,
  isProductActive: PropTypes.bool,
  urlParams: PropTypes.object,
};

export default ProductFamilyItem;



/** WEBPACK FOOTER **
 ** ./apps/maptool/components/ProductFamily/ProductFamilyItem.js
 **/